<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-list-item
        :class="{
          'unread-notification': !notification.isRead,
          'on-hover': hover,
        }"
        class="notification-item"
        @click="markItemAsRead(notification)"
      >
        <template v-slot:default="{ active, toggle }">
          <v-list-item-action class="mr-3" v-show="isSelected">
            <v-checkbox
              v-model="selected"
              :input-value="active"
              :value="notification.notificationLogId"
              color="red"
              @click.stop="toggle"
              @change="changeNotification"
            ></v-checkbox>
          </v-list-item-action>
          <NotificationTypeIcons
            v-show="!isSelected"
            :notiType="notification.eventTypeId"
            :payload="payload"
            :unread="!notification.isRead"
          />
          <v-list-item-content>
            <div
              :class="{ 'font-weight-bold': !notification.isRead }"
              class="mb-1"
            >
              <template v-if="notification.eventTypeId == deviceStatusUpdated">
                {{ $t('notifications.cameraStatusUpdated') }}
              </template>
              <template v-else>
                {{ notification.messageSubject }}
              </template>
            </div>
            <div class="text--disabled mb-1">
              {{ formattedDate(notification.createdOn) }}
            </div>
            <div class="mt-1">
              {{ notification.messageBody }}
            </div>
          </v-list-item-content>
          <v-btn
            v-if="showDeleteIcon && !isSelected"
            fab
            depressed
            dark
            height="26"
            width="26"
            color="secondary"
            :class="{ 'hide-btns': !hover }"
            @click.stop="deleteNotification(notification)"
          >
            <v-icon size="14" color="primary" class="trash-icon">
              $trashCan
            </v-icon>
          </v-btn>
        </template>
      </v-list-item>
    </v-hover>
    <v-divider />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { DateTime } from 'luxon'
import { formatDateTimeDisplay } from '@/utils/tools'
import NotificationTypeIcons from './NotificationTypeIcons.vue'
import { DEVICE_STATUS_UPDATED } from '@/constants/notificationTypes.js'

export default defineComponent({
  name: 'SingleNotification',
  props: {
    notification: {
      type: Object,
      required: true,
    },
    display24HourTime: {
      type: Boolean,
      required: true,
    },
    showDeleteIcon: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  components: {
    NotificationTypeIcons,
  },
  methods: {
    markItemAsRead(notification) {
      if (!this.isSelected) {
        this.$emit('markItemAsRead', notification)
      }
    },
    formattedDate(date) {
      let dt = DateTime.fromISO(date)
      return formatDateTimeDisplay(
        dt,
        this.display24HourTime,
        ' at ',
        false,
        false
      )
    },
    changeNotification(data) {
      let payload = {
        notificationId: this.notification.notificationLogId,
      }
      if (data.length === 0) {
        payload.type = 'remove'
        this.$emit('updateSelectedNotifications', payload)
      } else {
        payload.type = 'add'
        this.$emit('updateSelectedNotifications', payload)
      }
    },
    addSelected() {
      this.selected = [this.notification.notificationLogId]
    },
    removeSelected() {
      this.selected = []
    },
    deleteNotification(notification) {
      this.$emit('deleteSingleNotification', notification.notificationLogId)
    },
  },
  computed: {
    payload() {
      return JSON.parse(this.notification.notificationPayload)
    },
    deviceStatusUpdated() {
      return DEVICE_STATUS_UPDATED
    },
  },
})
</script>
<style lang="scss">
.notification-item {
  .hide-btns {
    display: none;
  }
  .trash-icon,
  svg {
    color: white !important;
    g {
      fill: white !important;
      color: white !important;
    }
  }
}
</style>
